import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

const HorizontalStepper: FC<Props> = ({ steps, actualStep }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => {
        const isActive = actualStep === step.type;

        if (step.hidden) {
          return <></>;
        }

        return (
          <div
            className={`${styles.step} ${isActive && styles.active}`}
            key={"stepper_step" + index}
          ></div>
        );
      })}
    </div>
  );
};

export default HorizontalStepper;
